import { Component, HostListener, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { FileCaptureService } from 'app/service/file-capture.service';
import { FileSizePipe } from '../pipes/file-size.pipe';
import { FileServiceService } from '../service/file-service.service';
import { HttpClient, HttpEventType } from '@angular/common/http';
import { NotificationService } from 'app/service/notification-service';
import { concatMap, from, map, toArray } from 'rxjs';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
    standalone: false,
    selector: 'app-file-upload',
    templateUrl: './file-upload.component.html',
    styleUrls: ['./file-upload.component.css']
})
export class FileUploadComponent implements OnInit {
    isFirst: any = true;
    files: any = [];
    showError: boolean = false;
    errorMsg: string = '';
    acceptedFiles: string = '.doc, .docx, .dcm, .pdf, .xls, .xlsx, .jpeg, .jpg, .bmp, .png, .tif, .tiff, .wav, .mp3, .txt, .text/plain, .mkv, .eml';
    FilesToUpload: any = [];
    canUpload: boolean = true;
    isViewOnly: boolean = false;
    isLoading: boolean = false;
    BufferChunkSize: any;
    hasUpdate: boolean;
    isDisabled: boolean = true;
    attestationAccepted: boolean = false;
    openUploadModal: boolean = false;
    uploadedFiles: File[] | null = null;
    showFileUploadError: boolean = false;
    fileSubmitted: boolean = false;
    showAcceptedFiles: boolean = false;
    notification: NotificationService;
    fileUploadMap: any = {};
    queue: any = [];
    totalUploadedFiles: any = 0;
    constructor(
        private route: Router, 
        private fcservice: FileCaptureService, 
        public service: FileServiceService, 
        private filesize: FileSizePipe, 
        private http: HttpClient,
        public notificationService: NotificationService,
        private ngxspinner: NgxSpinnerService
    ) {
    }

    ngOnInit(): void {
        this.notification = this.notificationService;

        const refData = this.service.getCache('contactEmail');
        if (refData) {
            this.service.setPageVisited('reference');
        }

        this.service.setPageVisited('file-upload');
        this.service.referenceFileDetails.routingOption = this.service.getCache('routingOption') || this.service.referenceFileDetails.routingOption;

        const cachedFiles = this.service.getCache('files');
        const attachmentSaved = this.service.getCache('attachmentSaved');

        if (cachedFiles && cachedFiles.length > 0) {
            this.files = [...cachedFiles];
            this.FilesToUpload = [...cachedFiles];
            this.service.referenceFileDetails.files = [...cachedFiles];
            this.isDisabled = this.files.length === 0 || this.attestationMissing;
            this.totalUploadedFiles = this.files.length;
        } else {
            this.files = [];
            this.FilesToUpload = [];
            this.isDisabled = true;
        }
    }

    get attestationEnabled(): boolean {
        return this.service.getConfigBoolean('AttestationEnabled', false);
    }

    get attestationText(): string {
        return this.service.getConfigValue('AttestationText', '');
    }

    get attestationMissing(): boolean {
        return this.attestationEnabled && !this.attestationAccepted;
    }

    next() {
        this.service.referenceFileDetails.files = [...this.FilesToUpload];
        this.service.setCacheForitems([{ id: 'files', value: [...this.FilesToUpload] }]);
        this.onSubmit();
    }

    @HostListener('window:dragover', ['$event'])
    allowDrag(e) {

        e.dataTransfer.dropEffect = 'copy';
    }

    @HostListener('window:drop', ['$event'])
    handleDrop(e) {
        this.uploadFiles(e.dataTransfer.files);
    }
    onFileChange(event: any) {
        const pFileList = event.files ? event.files : event;
        if (pFileList.length > 500) {
            this.showError = true;
            this.errorMsg = "Maximum of 500 files can be uploaded";
            return;
        }
        for (let index = 0; index < pFileList.length; index++) {
            const element = pFileList[index];
            const fileType = element.name.substring(element.name.lastIndexOf('.') + 1);
            if (!this.checkFileType(fileType)) {
                this.showError = true;
                this.errorMsg = "File type is not supported" + ', ' + element.name;
                return;
            }
            if (element.size > 1.5 * 1024 * 1024 * 1024) {
                this.showError = true;
                this.errorMsg = "File size should be less than 1.5 GB" + ', ' + element.name;
                return;
            } else {
                this.showError = false;
            }
        }
        this.isDisabled = true;
        this.uploadFiles(event);
    }


    uploadFiles(event: any) {
    const files = event.files ? event.files : event;
    const existingFiles = this.service.getCache('files') || [];

    if (!this.FilesToUpload || this.FilesToUpload.length === 0) {
        this.FilesToUpload = [...existingFiles];
    }

    let duplicateFileExist = false;
    const incomingFiles = Array.from(files);

    duplicateFileExist = incomingFiles.some((incoming: any) =>
        this.FilesToUpload.some((existing: any) => (existing.fileName ?? existing.name) === incoming.name)
    );

    if (files.length > 0 && !duplicateFileExist) {
        for (let i = 0; i < incomingFiles.length; i++) {
        const currentFile: any = incomingFiles[i];

        const attachment = {
            fileName: currentFile.name,
            fileType: currentFile.name.substring(currentFile.name.lastIndexOf('.') + 1),
            percentage: 0,
            fileSize: currentFile.size || 0,
            sizeReadable: this.humanFileSize(currentFile.size || 0, true),
            isFirst: !this.service.getCache('attachmentSaved'),
            fileId: this.FilesToUpload.length,
            activityName: 'Deconfliction',
            attachmentLength: currentFile.size,
            targetFile: currentFile,
            referenceId: this.service.getCache('referenceId'),
            isUpload: 1
        };

        this.FilesToUpload.push(attachment);
        this.fcservice.fileArray.push(currentFile);
        }

        this.files = [...this.FilesToUpload];
        this.service.setCacheForitems([{ id: 'files', value: [...this.FilesToUpload] }]);
        this.isDisabled = this.files.length === 0 || this.attestationMissing;
    }
    }

    humanFileSize(bytes: any, si: any) {
        var thresh = si ? 1000 : 1024;
        if (Math.abs(bytes) < thresh) {
            return bytes + ' B';
        }
        var units = si
            ? ['kB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']
            : ['KiB', 'MiB', 'GiB', 'TiB', 'PiB', 'EiB', 'ZiB', 'YiB'];
        var u = -1;
        do {
            bytes /= thresh;
            ++u;
        } while (Math.abs(bytes) >= thresh && u < units.length - 1);
        return bytes.toFixed(1) + ' ' + units[u];
    }

    checkFileType(fileType) {
        switch (fileType.toLowerCase()) {
            case "doc":
                return true;
            case "docx":
                return true;
            case "pdf":
                return true;
            case "dcm":
                return true;
            case "xls":
                return true;
            case "xlsx":
                return true;
            case "jpeg":
                return true;
            case "jpg":
                return true;
            case "bmp":
                return true;
            case "png":
                return true;
            case "tif":
                return true;
            case "tiff":
                return true;
            case "wav":
                return true;
            case "mp3":
                return true;
            case "txt":
                return true;
            case "text/plain":
                return true;
            case "htm":
                return true;
            case "html":
                return true;
            case "csv":
                return true;
            case "ppt":
                return true;
            case "pptx":
                return true;
            case "eml":
                return true;
            case "mkv":
                return true;
            default:
                return false;
        }
    }

    back() {
        this.route.navigate(['routing']);
    }

    cancel() {
        const sessionId = window.sessionStorage.getItem(this.fcservice.SESSION_KEY) || '';
        const payorKey = Number(window.sessionStorage.getItem(this.fcservice.PAYOR_KEY) || 0);
        const referenceId = this.service.referenceFileDetails.referenceId || this.service.getCache('referenceId');

        this.fcservice.releaseActiveReferenceLock(payorKey, referenceId, sessionId).subscribe();

        this.service.referenceFileDetails.referenceId = "";
        this.service.clearCache();
        let url = window.localStorage.getItem('securityCode');
        this.route.navigate(['/' + url]);
    }

    onUpload(files: any): void {
        var i = 0;
        for (const file of files) {
            const formData = new FormData();
            var jsonData = JSON.stringify({
                referenceid: this.service.getCache('referenceId'),
                activityName: 'Deconfliction',
                isFirst: i == 0
            });

            formData.append('jsonData', jsonData);
            formData.append('files', file, file.name);
            i++;
            this.fcservice.addFilesToDB(formData).subscribe(event => {
                if (event.type === HttpEventType.UploadProgress) {
                    console.log('Upload Progress: ' + Math.round(100 * event.loaded / event.total) + '%');
                } else if (event.type === HttpEventType.Response) {
                    console.log('Upload complete');
                }
            });
        }

    }
    closeNotification(index: number) {
        this.notification.queue.splice(index, 1);
    }

    removeFile(index: number) {
        this.files.splice(index, 1);
        this.FilesToUpload.splice(index, 1);
        this.service.setCacheForitems([{ id: "files", value: this.FilesToUpload }]);
        this.isDisabled = this.FilesToUpload.length == 0 || this.attestationMissing;
    }

    onAttestationChange(): void {
        this.isDisabled = this.FilesToUpload.length === 0 || this.attestationMissing;
    }

    toggleAcceptedFiles(): void {
        this.showAcceptedFiles = !this.showAcceptedFiles;
    }

    onSubmit() {
        if (this.FilesToUpload.length === 0 || this.attestationMissing) {
            this.isDisabled = true;
            return;
        }

        const newFiles = this.files.filter(x => x.isUpload == 1);
        if (newFiles.length > 0) {
            this.uploadedFiles = this.fcservice.fileArray;
            this.openUploadModal = true;
            return;
        }
        this.submitFinalDocument();
    }

    handleUploadCompleted(event: any) {
        this.openUploadModal = false;

        const successfulFiles = event.files.filter((x: any) =>
            x.attachmentKey &&
            x.scanStatus === 1 &&
            x.percentage !== 500 &&
            x.percentage !== 600 &&
            x.uploadFailed !== true &&
            x.failureToUpload !== true &&
            x.scanStatus !== 99
        );

        const allFilesSucceeded =
            event.hasInvalidFiles !== true &&
            event.hasUploadErrors !== true &&
            successfulFiles.length === event.files.length;

        this.files = allFilesSucceeded ? successfulFiles : event.files;
        this.service.referenceFileDetails.files = this.files;
        this.service.setCacheForitems([{ id: 'files', value: this.files }]);
        if (allFilesSucceeded) {
            this.showFileUploadError = false;
            this.submitFinalDocument();
            return;
        }

        this.showFileUploadError = true;
        this.isDisabled = false;
    }

    submitFinalDocument() {
        const validFiles = this.files.filter((x: any) =>
            x.attachmentKey &&
            x.scanStatus === 1 &&
            x.isVisible !== x.attachmentKey + '_99' &&
            x.uploadFailed !== true &&
            x.failureToUpload !== true &&
            x.scanStatus !== 99 &&
            x.percentage !== 500 &&
            x.percentage !== 600
        );

        if (validFiles.length !== this.files.length) {
            this.showFileUploadError = true;
            this.isDisabled = false;
            return;
        }

        const submitPayloads = this.buildSubmitPayloads(validFiles);
        if (!submitPayloads.length) {
            this.showFileUploadError = true;
            this.isDisabled = false;
            return;
        }

        this.ngxspinner.show();
        from(submitPayloads).pipe(
            concatMap((payload: any) =>
                this.fcservice.submitDocument(payload).pipe(
                    map((res: boolean) => ({ payload, res }))
                )
            ),
            toArray()
        ).subscribe({
            next: (results: any[]) => {
                const allSucceeded = results.every((result: any) => result.res === true);
                this.fileSubmitted = allSucceeded;
                this.ngxspinner.hide();
                if (!allSucceeded) {
                    this.showFileUploadError = true;
                    this.isDisabled = false;
                    return;
                }

                const sessionId = window.sessionStorage.getItem(this.fcservice.SESSION_KEY) || '';
                const payorKey = Number(window.sessionStorage.getItem(this.fcservice.PAYOR_KEY) || 0);
                const referenceId = this.service.referenceFileDetails.referenceId || this.service.getCache('referenceId');
                this.fcservice.releaseActiveReferenceLock(payorKey, referenceId, sessionId).subscribe();

                this.service.referenceFileDetails.submittedDate = new Date();
                this.service.referenceFileDetails.submittedFileCount = validFiles.length;
                this.service.setCacheForitems([
                    { id: 'submittedDate', value: this.service.referenceFileDetails.submittedDate },
                    { id: 'submittedFileCount', value: validFiles.length },
                    { id: 'attachmentSaved', value: null },
                    { id: 'caseActivityKey', value: null },
                    { id: 'attachmentSavedForRef', value: null },
                    { id: 'files', value: null }
                ]);

                this.fcservice.fileArray = [];
                this.route.navigate(['confirmation']);
            },
            error: () => {
                this.ngxspinner.hide();
                this.showFileUploadError = true;
                this.isDisabled = false;
            }
        });
    }

    private buildSubmitPayloads(validFiles: any[]): any[] {
        const groupedFiles = new Map<any, any[]>();

        validFiles.forEach((file: any) => {
            const groupKey = file.serverCaseActivityKey || file.caseActivityKey || this.service.referenceFileDetails.caseActivityKey || this.service.getCache('caseActivityKey');
            const existingFiles = groupedFiles.get(groupKey) || [];
            existingFiles.push(file);
            groupedFiles.set(groupKey, existingFiles);
        });

        return Array.from(groupedFiles.entries()).map(([caseActivityKey, files]) => ({
            BusinessName: this.service.referenceFileDetails.organizationName || this.service.getCache('organizationName') || this.service.referenceFileDetails.businessName,
            ContactName: this.service.referenceFileDetails.contactName || this.service.getCache('contactName'),
            ContactPhone: this.service.referenceFileDetails.contactPhone || this.service.getCache('contactPhone'),
            ContactEmail: this.service.referenceFileDetails.contactEmail || this.service.getCache('contactEmail'),
            FirstName: this.service.referenceFileDetails.firstName || this.service.getCache('firstName'),
            LastName: this.service.referenceFileDetails.lastName || this.service.getCache('lastName'),
            Title: this.service.referenceFileDetails.title || this.service.getCache('title'),
            organizationName: this.service.referenceFileDetails.organizationName || this.service.getCache('organizationName'),
            MailingAddress1: this.service.referenceFileDetails.mailingAddress1 || this.service.getCache('mailingAddress1'),
            MailingAddress2: this.service.referenceFileDetails.mailingAddress2 || this.service.getCache('mailingAddress2'),
            MailingCity: this.service.referenceFileDetails.mailingCity || this.service.getCache('mailingCity'),
            MailingState: this.service.referenceFileDetails.mailingState || this.service.getCache('mailingState'),
            MailingZip: this.service.referenceFileDetails.mailingZip || this.service.getCache('mailingZip'),
            RoutingOption: this.service.referenceFileDetails.routingOption || this.service.getCache('routingOption'),
            ReferenceId: this.service.referenceFileDetails.referenceId || this.service.getCache('referenceId'),
            CaseActivityKey: caseActivityKey,
            ActiveAttachmentKey: files.map((file: any) => file.attachmentKey),
            TimeZoneUtcDifference: new Date().getTimezoneOffset()
        }));
    }

    closeUploadPopup() {
        this.openUploadModal = false;
    }
}
